// Global ⌘K / Ctrl+K palette for jumping between dev agents.
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import { useDevAgents } from "@/hooks/useDevAgents";
import DevIcon from "@/components/dev/DevIcon";

export default function CommandPalette() {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const { data: agents } = useDevAgents();

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setOpen((o) => !o);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const go = (path: string) => { setOpen(false); nav(path); };

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Jump to agent..." />
      <CommandList>
        <CommandEmpty>No agent found.</CommandEmpty>
        <CommandGroup heading="Dev agents">
          {(agents ?? []).map((a) => (
            <CommandItem key={a.id} value={`${a.name} ${a.slug} ${a.description}`} onSelect={() => go(`/dev/${a.slug}`)}>
              <DevIcon name={a.icon} className="w-4 h-4 mr-2 text-primary" />
              <span className="font-mono">{a.name}</span>
              <span className="text-muted-foreground ml-2 text-xs">/{a.slug}</span>
            </CommandItem>
          ))}
        </CommandGroup>
        <CommandGroup heading="Navigate">
          <CommandItem value="dev home" onSelect={() => go("/dev")}>All agents</CommandItem>
          <CommandItem value="home" onSelect={() => go("/")}>Home</CommandItem>
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}